<template>
    <div>
        <form @submit="saveContent">
            <div class="mb-2">
                <b-form-group label="Subject" label-for="subject" :invalid-feedback="errors.subject" :state="!errors.subject">
                    <b-input-group size="sm" :append="subSuffix">
                        <b-form-input
                            class="form-control-sm"
                            v-model="stepObj.subject"
                            :state="!errors.subject ? null : false"
                            @input="()=>errors.subject = null"
                            trim
                            placeholder="Subject"
                            required
                        />
                    </b-input-group>
                </b-form-group>
            </div>
            <div class="mb-2">
                <label>Template Name</label>
                <input type="text" placeholder="Template Name" class="form-control form-control-sm" v-model="stepObj.template_name" required>

            </div>
            <div class="mb-3">
                <label>Template</label>
                <select class="form-control form-control-sm" v-model="selectedOption" @change="selectTemplate" >
                    <option  value="" selected disabled>Select Template</option>
                    <option v-for="emailTemplate in emailTemplates" :value="emailTemplate" :name="emailTemplate.template_name">{{emailTemplate.template_name}}</option>
                </select>
            </div>

            <div class="mb-3">
                <div class="flex flex-row w-full border-1 shadow-md mr-2 mb-2 p-1 align-items-center text-sm justify-content-between">
                    <p class="pr-1"><b>Send email in</b></p>
                    <select class="dayDropdown" v-model="stepObj.send_email_in">
                        <option v-for="n in noOfDays" :value="n">{{ n }}</option>
                    </select>
                    <select class="dayDropdown" v-model="stepObj.step_unit">
                        <option value="Days">Days</option>
                        <option value="Weeks">Week</option>
                    </select>
                    <div style="width: 20%; position: relative;">
                        <div style="position: absolute; left: 10px;">
                            <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <datetime
                            type="time"
                            v-model="stepObj.step_time"
                            name="scheduled_time"
                            format="hh:mm a"
                            use12-hour
                            :minute-step="15"
                            input-style="width:100% !important; padding-left:30px;"
                            required id="scheduled_time"
                            class="border-1 text-grey-darkest text-sm sequence-timepicker w-100"
                        ></datetime>
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <multiselect
                    id="selectFields"
                    :options="fields"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="false"
                    :taggable="false"
                    open-direction="below"
                    placeholder="Select field to add in editor"
                    :showLabels="false"
                    label="text"
                    track-by="id"
                    :preselect-first="false"
                    @select="fieldSelected"
                    group-values="optionValues"
                    group-label="optionTypes"
                    :group-select="false"
                >
                </multiselect>
            </div>

            <ckeditor
                :config="editorConfig"
                :editor="editor"
                :value="stepObj.content"
                @ready="onReady"
                @input="emit"
            >
            </ckeditor>
            <span style="color: red">{{ sequenceValueError }}</span>
            <input type="hidden" name="sequenceHidden" />

            <div class="mt-3" v-if="!this.showSendTestBtn">
                <b-button v-if="isUpdate" class="bg-primary float-left" pill variant="info" type="button" @click="deleteStep">
                    Delete Step
                </b-button>
                <b-button v-if="isUpdate" class="bg-primary float-right" pill variant="info" type="submit">
                    Update Step
                </b-button>
                <b-button v-else class="bg-primary float-right" pill variant="info" type="submit">
                    Save Step
                </b-button>
            </div>

            <div class="mt-3" v-else>
                <b-button class="bg-primary float-left" pill variant="info" type="button" @click="sendTestEmail">
                    <i v-if="sendingTestEmail" class="fa fa-btn fa-spinner fa-spin"></i>
                    Send test email
                </b-button>
            </div>

        </form>

    </div>
</template>

<script>

import Vue from "vue";

const customColorPalette = [
    {
        color: 'rgb(0, 0, 0)',
        label: 'Black'
    },
    {
        color: 'rgb(77, 77, 77)',
        label: 'Dim grey'
    },
    {
        color: 'rgb(153, 153, 153)',
        label: 'Grey'
    },
    {
        color: 'rgb(230, 230, 230)',
        label: 'Light grey'
    },
    {
        color: 'rgb(255, 255, 255)',
        label: 'White',
        hasBorder: true
    },
    {
        color: 'rgb(230, 76, 76)',
        label: 'Red'
    },
    {
        color: 'rgb(230, 153, 76)',
        label: 'Orange'
    },
    {
        color: 'rgb(230, 230, 76)',
        label: 'Yellow'
    },
    {
        color: 'rgb(153, 230, 76)',
        label: 'Light green'
    },
    {
        color: 'rgb(76, 230, 76)',
        label: 'Green'
    },
    {
        color: 'rgb(76, 230, 153)',
        label: 'Aquamarine'
    },
    {
        color: 'rgb(76, 230, 230)',
        label: 'Turquoise'
    },
    {
        color: 'rgb(76, 153, 230)',
        label: 'Light blue'
    },
    {
        color: 'rgb(76, 76, 230)',
        label: 'Blue'
    },
    {
        color: 'rgb(153, 76, 230)',
        label: 'Purple'
    }
];

import CKEditor   from 'ckeditor4-vue';
import Multiselect from 'vue-multiselect';
import moment from "moment";
Vue.use(CKEditor);

export default {
    components: {
        ckeditor: CKEditor.component,
        Multiselect
    },
    name: "ckeditor-sequence",
    props  : ['project', 'sequence', 'selectedStepObj', 'allFields', 'showSendTestBtn', 'selectedContactForSequence', 'subSuffix'],
    data() {
        return {
            selectedField: null,
            isUpdate:false,
            textData:"",
            emailTemplates:[],
            sequenceValue: '',
            sequenceEditor: null,
            extraPlugins : 'widget',
            sequenceId: null,
            stepObj: {
                id: null,
                subject: '',
                template_name: '',
                template_id: null,
                email_sequence_id: null,
                send_email_in: 1,
                step_unit: 'Days',
                step_time: '',
                content: '',
            },
            selectedOption: '',
            errors: {
                subject: null,
            },
            editor:CKEditor,
            editorConfig: {
                // height: 530,
                resize_enabled: false,
                removePlugins:'easyimage,image',
                extraPlugins : 'pastefromword,widget,pastefromgdocs,uploadimage,uploadwidget,image2',
                autoEmbed_widget: 'addSignature,addInitials,addDate,contactName,contactEmail,contactCompany,projectAddress,baseBid',
                autoUpdateElement: true,
                allowedContent:true,
                removeButtons:'Save,NewPage,ExportPdf,Preview,Subscript,Superscript,CopyFormatting,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Scayt,SelectAll,Find,Replace,Redo,Undo,Cut,Copy,Paste,PasteText,PasteFromWord,Templates,Source,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Format,Font,Maximize,ShowBlocks,About,Print',
                language: 'en',
                fontSize: {
                    options: ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
                },
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:full',
                        'imageStyle:side'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                    ],
                    tableProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    },
                    tableCellProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    }
                },
                fontBackgroundColor: {
                    colors: customColorPalette
                },
                fontColor: {
                    colors: customColorPalette
                },
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            feed: this.getFeedItems,
                            minimumCharacters: 1
                        }
                    ]
                },
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                pasteFromWordNumberedHeadingToList:true,
                pasteFromWord_inlineImages: true,
                pasteFromWordRemoveStyles: true,
                pasteFromWordRemoveFontStyles: true,
                contentsCss: '/css/ckeditor-sequence.css',
            },
            sequenceValueError:'',
            fields: [],
            noOfDays: 30,
            sendingTestEmail: false
        };
    },
    created() {

    },
    mounted(){
        this.fetchTemplate();
        this.fields = this.allFields
    },
    watch:{
        selectedStepObj: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if(newVal){
                    this.isUpdate = true
                    this.stepObj = {
                        id: newVal.id,
                        subject: newVal.subject,
                        template_name: newVal.template_name,
                        template_id: newVal.template_id,
                        email_sequence_id: newVal.email_sequence_id,
                        send_email_in: newVal.send_email_in,
                        step_unit: newVal.step_unit,
                        step_time: newVal.step_time,
                        content: newVal.content
                    };

                    if(newVal.template_id){
                        this.selectedOption = this.emailTemplates.find(x => x.id === newVal.template_id)
                    }
                }else{
                    this.isUpdate = false
                }
            },
            deep: true
        }
    },
    methods: {
        fieldSelected(selectedOption, id) {
            let data = [];
            data['button'] = selectedOption.button;
            data['text'] = selectedOption.text;
            data['buttonCode'] = selectedOption.buttonCode;

            this.sequenceEditor.widgets.add( data['button'], {
                inline: true,
                template: '<span><span class="'+data['button']+' cke_widget_element projectDataShow" data-cke-widget-upcasted="1" style="pointer-events: none;border: 1px solid #01b1af;font-size: 12px;padding: 1px 5px;color: #01b1af;text-align: center;width: 170px;margin-right:5px;maring-left:5px" disabled>'+data['text']+'</span><span class="projectDataHidden">$'+data['buttonCode']+'</span></span>',
                upcast: function( element ) {
                    return element.name === 'span' && element.hasClass( data['button'] );
                },
                init: function() {
                }
            } );

            this.sequenceEditor.execCommand(data['button']);
        },
        fetchTemplate() {
            let params = {
                filter: "",
                column: "",
                direction: "",
                page: "",
                template_type: "sequence"
            };
            axios.get(route('api.template.index'), {params}).then(({data}) => {
                this.emailTemplates = data.data;
            });
        },
        saveContent() {
            event.preventDefault();

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if(this.sequenceEditor.getData() === '' || !this.sequenceEditor.getData()){
                this.sequenceValueError = 'Please fill the sequence.';
                return false;
            }else{
                this.sequenceValueError = '';
            }

            if(this.sequence.name === '' || !this.sequence.name){
                Bus.$emit('onSequenceNameEmpty','true');
                return false;
            }

            let data = {
                sequence_name: this.sequence.name,
                sequence_id: this.sequence.id ?? null,
                step_id: this.stepObj.id ?? null,
                subject: this.stepObj.subject,
                template_name: this.stepObj.template_name,
                send_email_in: this.stepObj.send_email_in,
                step_unit: this.stepObj.step_unit,
                step_time: this.stepObj.step_time,
                template_id: this.selectedOption.id ?? null,
                content: this.sequenceEditor.getData(),
                sequence_type: this.project ? 'project' : 'contact',
                project_id: this.project ? this.project.id : null,
                company_contact_id: this.selectedContactForSequence ? this.selectedContactForSequence.id : null
            }


            if(this.isUpdate){
                axios.put(route('api.sequence.update', {sequence: data.sequence_id}), data)
                    .then((response) => {
                        if(response.data.status){
                            Toast.fire({
                                type: 'success',
                                title: response.data.message
                            });
                            Bus.$emit('stepUpdated',response.data.sequenceStep);
                            this.resetStepObj()
                        }else{
                            Toast.fire({
                                type: 'error',
                                title: response.data.message
                            });
                        }

                    });
            }else{
                axios.post(route('api.sequence.store'),  data)
                    .then((response) => {
                        if(response.data.status){
                            Toast.fire({
                                type: 'success',
                                title: response.data.message
                            });
                            Bus.$emit('newStepAdded',response.data.sequenceStep);
                            if(response.data.isNewSequence){
                                Bus.$emit('newSequenceAdded',response.data.sequence);
                            }
                            this.resetStepObj()
                        }else{
                            Toast.fire({
                                type: 'error',
                                title: response.data.message
                            });
                        }
                    });
            }

        },
        deleteStep() {
            event.preventDefault();
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if(this.selectedStepObj && this.selectedStepObj.id){
                Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete this step?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: false,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then(result => {

                    if (result.value) {
                        axios.delete(route('api.sequence.destroy', {sequence: this.selectedStepObj.id}))
                            .then((response) => {
                                if(response.data.status){
                                    Toast.fire({
                                        type: 'success',
                                        title: response.data.message
                                    });
                                    Bus.$emit('stepDeleted', 'true');
                                    this.resetStepObj()
                                }else{
                                    Toast.fire({
                                        type: 'error',
                                        title: response.data.message
                                    });
                                }
                            });
                    }
                });
            }
        },
        emit(value, batch) {
            this.sequenceValue = value;
            this.sequenceValueError = '';
        },
        onReady( editor )  {
            this.sequenceEditor = editor;
        },

        addField(button, text, buttonCode){
            console.log(button, text, buttonCode);
            return false;
            let data = [];
            data['button'] = button;
            data['text'] = text;
            data['buttonCode'] = buttonCode;

            this.sequenceEditor.widgets.add( data['button'], {
                inline: true,
                template: '<span><span class="'+data['button']+' cke_widget_element projectDataShow" data-cke-widget-upcasted="1" style="pointer-events: none;border: 1px solid #01b1af;font-size: 12px;padding: 1px 5px;color: #01b1af;text-align: center;width: 170px;margin-right:5px;maring-left:5px" disabled>'+data['text']+'</span><span class="projectDataHidden">$'+data['buttonCode']+'</span></span>',
                upcast: function( element ) {
                    return element.name === 'span' && element.hasClass( data['button'] );
                },
                init: function() {
                }
            } );

            this.sequenceEditor.execCommand(data['button']);
        },
        selectTemplate(e){
            this.stepObj.template_name = this.selectedOption.template_name
            this.sequenceEditor.setData(this.selectedOption.template_text)
        },
        resetStepObj(){
            this.stepObj = {
                id: null,
                subject: '',
                template_name: '',
                template_id: null,
                email_sequence_id: null,
                send_email_in: 1,
                step_unit: 'Days',
                step_time: '',
                content: '',
            };
            this.selectedOption = '';
            this.sequenceEditor.setData('')
        },
        sendTestEmail() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            let data = {
                subject: this.stepObj.subject,
                template_name: this.stepObj.template_name,
                content: this.sequenceEditor.getData(),
                contact_id: this.selectedContactForSequence ? this.selectedContactForSequence.id : null,
                contact_type: this.selectedContactForSequence ? this.selectedContactForSequence.type : null,
                project_id: this.project ? this.project.id : null
            }
            this.sendingTestEmail = true
            axios.post(route('api.sequence.test-email'),  data)
                .then((response) => {
                    this.sendingTestEmail = false;
                    if(response.data.status){
                        Toast.fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }else{
                        Toast.fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
        }
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 200px;
}

a.cke_button_off:hover, a.cke_button_off:focus, a.cke_button_off:active {
    background: #e5e5e5;
    border: 1px #bcbcbc solid;
    padding: 2px 5px !important;
}
a.cke_button_expandable.cke_button_off:hover, a.cke_button_expandable.cke_button_off:focus, a.cke_button_expandable.cke_button_off:active {
    padding: 2px 2px !important;
}
.cke_toolgroup{
    display:contents !important;
}
.cke_editable p, .cke_editable div{
    margin:0 !important;
}
.dayDropdown{
    background: #e6e8eb;
    height: 100%;
    padding: 0px 8px;
    border-radius: 4px;
}
</style>
